import { api } from '@/lib/api-client';

export interface DashboardOverview {
  tenant: { usersTotal: number; usersActive: number; rolesTotal: number };
  activity: { loginsLast7Days: number; failedLoginsLast7Days: number };
  registrations: { customers: number; suppliers: number; products: number; materials: number };
  stock: {
    totalValue: string;
    itemsWithStock: number;
    belowMinimumCount: number;
    woodVolumeM3: string;
    movementsLast7Days: number;
  };
  production: {
    producedToday: string;
    producedMonth: string;
    openOrders: number;
    inProgressOrders: number;
    lateOrders: number;
    lossPercent: string;
    pendingSalesOrders: number;
    openPurchaseOrders: number;
    openQuotations: number;
  };
  financial: {
    monthRevenue: string;
    monthReceived: string;
    monthPaid: string;
    cashBalance: string;
    payablesOpen: string;
    receivablesOpen: string;
    payablesOverdue: string;
    receivablesOverdue: string;
    monthResult: string;
    monthly: { month: string; income: string; expense: string; result: string }[];
  };
  people: {
    activeEmployees: number;
    onLeave: number;
    pendingHrEntries: number;
    assetsTotal: number;
    assetsInMaintenance: number;
    overduePlans: number;
    openMaintenance: number;
    lateMaintenance: number;
  };
  modules: { code: string; label: string; phase: number; available: boolean }[];
  generatedAt: string;
}

export const dashboardApi = { overview: () => api.get<DashboardOverview>('/dashboard/overview') };
export const dashboardKeys = { overview: ['dashboard', 'overview'] as const };
